import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from '../index'

export const selectListsById = (state: RootState) => state.lists.byId
export const selectListsAllIds = (state: RootState) => state.lists.allIds
export const selectListsLoading = (state: RootState) => state.lists.loading
export const selectListsError = (state: RootState) => state.lists.error

export const selectAllLists = createSelector(
    [selectListsById, selectListsAllIds],
    (byId, allIds) => allIds.map((id: string) => byId[id]).filter(Boolean)
)

export const selectListById = (state: RootState, listId: string) =>
    state.lists.byId[listId]
